import { graphql } from 'gatsby';
import React from 'react';
import PropTypes from 'prop-types';

import HalfWidthFeatureCtas from '~/components/blocks/acf/HalfWidthFeatureCtas';

import { AcfLink } from '~/utilities/propTypes';

import halfWidth1 from '~/images/exampleBlocks/halfWidth1.png';
import halfWidth2 from '~/images/exampleBlocks/halfWidth2.png';

const HalfWidthFeatureCtasBlock = ({
    attributes,
    globalBlockOptions: { globalBlockOptions },
    blockHalfWidthFeatureCtas
}) => (
    <HalfWidthFeatureCtas
        {...{
            ...blockHalfWidthFeatureCtas,
            globalBlockOptions,
            attributes
        }}
    />
);

HalfWidthFeatureCtasBlock.propTypes = {
    blockHalfWidthFeatureCtas: PropTypes.shape({
        ctas: PropTypes.arrayOf(
            PropTypes.shape({
                isLink: PropTypes.bool,
                link: AcfLink,
                title: PropTypes.string,
                copy: PropTypes.string,
                image: PropTypes.shape({})
            })
        ).isRequired
    }).isRequired
};

export default HalfWidthFeatureCtasBlock;

export const fragment = graphql`
    fragment HalfWidthFeatureCtasBlockFragment on WpAcfHalfWidthFeatureCtasBlock {
        name
        attributes {
            anchor
            className
        }
        globalBlockOptions {
            globalBlockOptions {
                marginBottom
            }
        }
        blockHalfWidthFeatureCtas {
            ctas {
                isLink
                link {
                    url
                    title
                }
                title
                copy
                image {
                    altText
                    sourceUrl
                    localFile {
                        childImageSharp {
                            gatsbyImageData(width: 600)
                        }
                    }
                }
            }
        }
    }
`;

export const exampleData = [
    {
        variant: 'Default Half Width Feature CTAs',
        description:
            'Optionally use link. Recommended Image Size: 1.03 Aspect Ratio, Minimum 300px x 290px. Intended to be a png.',
        props: {
            name: 'acf/half-width-feature-ctas',
            blockHalfWidthFeatureCtas: {
                ctas: [
                    {
                        isLink: false,
                        title: 'Just Title, No Link',
                        copy: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
                        image: {
                            sourceUrl: halfWidth1
                        }
                    },
                    {
                        isLink: true,
                        link: {
                            title: 'Link Title',
                            url: '#'
                        },
                        image: {
                            sourceUrl: halfWidth2
                        }
                    }
                ]
            }
        }
    }
];
